module.exports = __webpack_public_path__ + "static/media/logo-white.e6bcbb3f.svg";